import * as React from "react"

const SvgComponent = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
  const w = 50
  const h = 50
  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="50" height="50" rx="25" fill="white" />
      <path d="M31.8126 24.8908L31.8126 24.8908L31.817 24.8935C31.8355 24.9046 31.8507 24.9203 31.8613 24.9391L32.7321 24.4474L31.8613 24.9391C31.8719 24.9578 31.8775 24.979 31.8775 25.0005C31.8775 25.0221 31.8719 25.0432 31.8613 25.062C31.8507 25.0807 31.8355 25.0964 31.817 25.1076L31.817 25.1075L31.8126 25.1103L21.6876 31.2907L21.6804 31.2951L21.6733 31.2996C21.6594 31.3084 21.6434 31.3132 21.6269 31.3135C21.6105 31.3138 21.5942 31.3096 21.58 31.3013L21.5689 31.2949L21.5576 31.2887C21.5401 31.2791 21.5255 31.2649 21.5154 31.2478L20.6541 31.7559L21.5154 31.2478C21.5053 31.2306 21.4999 31.211 21.5 31.1911V31.188V18.813H21.5L21.5 18.81C21.4999 18.7901 21.5053 18.7705 21.5154 18.7533C21.5255 18.7361 21.5401 18.722 21.5576 18.7124L21.5689 18.7062L21.58 18.6997C21.5942 18.6914 21.6104 18.6872 21.6269 18.6875C21.6434 18.6878 21.6594 18.6926 21.6733 18.7015L21.6804 18.7059L21.6876 18.7103L31.8126 24.8908Z" fill="#616161" stroke="#616161" strokeWidth="2" />
    </svg>


  )
}

export default SvgComponent
